document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menuPanel = document.querySelector('[data-mobile-menu]');

  if (menuButton && menuPanel) {
    menuButton.addEventListener('click', () => {
      const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!isOpen));
      menuPanel.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });

    menuPanel.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        menuButton.setAttribute('aria-expanded', 'false');
        menuPanel.hidden = true;
        document.body.classList.remove('menu-open');
      });
    });
  }

  document.querySelectorAll('[data-accordion-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const content = document.getElementById(button.getAttribute('aria-controls'));
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      if (content) content.hidden = isOpen;
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const previous = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    let activeIndex = 0;
    let scrollTimer;

    if (!track || slides.length === 0) return;

    const updateControls = (index) => {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      thumbs.forEach((thumb, thumbIndex) => {
        const isActive = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
      if (previous) previous.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === slides.length - 1;
    };

    const goTo = (index, behavior = 'smooth') => {
      const targetIndex = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({ left: slides[targetIndex].offsetLeft, behavior });
      updateControls(targetIndex);
    };

    gallery.goToIndex = goTo;
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => goTo(Number(thumb.dataset.index))));
    if (previous) previous.addEventListener('click', () => goTo(activeIndex - 1));
    if (next) next.addEventListener('click', () => goTo(activeIndex + 1));

    track.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        const closestIndex = slides.reduce((bestIndex, slide, index) => (
          Math.abs(slide.offsetLeft - track.scrollLeft) < Math.abs(slides[bestIndex].offsetLeft - track.scrollLeft) ? index : bestIndex
        ), 0);
        updateControls(closestIndex);
      }, 80);
    }, { passive: true });

    updateControls(0);
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('[data-variant-select]');
    const productSection = form.closest('[data-section-id]');
    const price = productSection ? productSection.querySelector('[data-product-price]') : form.querySelector('[data-product-price]');
    const button = form.querySelector('[data-add-button]');
    if (!select) return;

    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (button) {
        button.disabled = option.dataset.available !== 'true';
        button.textContent = option.dataset.available === 'true' ? button.dataset.availableText : button.dataset.soldOutText;
      }
      if (option.dataset.mediaId && productSection) {
        const gallery = productSection.querySelector('[data-product-gallery]');
        const matchingSlide = gallery ? gallery.querySelector(`[data-gallery-slide][data-media-id="${option.dataset.mediaId}"]`) : null;
        if (gallery && matchingSlide && typeof gallery.goToIndex === 'function') {
          const gallerySlides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
          gallery.goToIndex(gallerySlides.indexOf(matchingSlide));
        }
      }
    });
  });
});
